/**
 * Slide number click toggles overview.
 */

export function setupSlideNumberToggleOverview(): void {
  const el = document.querySelector('.reveal');
  if (!el) return;
  el.addEventListener('click', ((e: Event) => {
    const a = (e.target as Element)?.closest?.('.slide-number a');
    if (!a) return;
    e.preventDefault();
    if (typeof Reveal !== 'undefined' && typeof Reveal.toggleOverview === 'function') {
      Reveal.toggleOverview();
    }
  }) as EventListener, true);
}
